import "./trackingaction.css";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { locationIcon, carIcon } from "../..//components/Maps/Icons";
import { osm } from "../..//components/Maps/osm-provider";
import { FaAngleDown, FaAngleUp, FaCar } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";

export default function Trackingaction({
  incomingdata,
  activeVehicle,
  activeImei,
}) {
  //L.map("map", { rotate: true, touchRotate: true }).setView([55, 10], 4);

  const [findme, setFindme] = useState(false);
  const [long, setLong] = useState("36.824954176738814");
  const [lat, setLat] = useState("-1.2851392128361565");
  const [click, setClick] = useState(false);
  const [speed, setSpeed] = useState("");
  const [engine, setIgnition] = useState("");
  const [battery, setBattery] = useState("");
  const [gsm_level, setGsm_level] = useState("");
  const [liion, setLiion] = useState("");
  const [state, setState] = useState("");
  const [trackedsates, setTrackedSatelites] = useState("");
  //const [altitude, setAltitude] = useState("");
  const [total_sates, setTotalsates] = useState("");
  const ZOOM_LEVEL = 15;
  const handleClick = () => {
    setClick(click === false ? true : false);
  };

  useEffect(() => {
    const lastdata = localStorage.getItem("datass");
    if (lastdata) {
      var data = lastdata.split(",");
      setLat(data[6].split(":")[1]);
      setLong(data[7].split(":")[1]);
    } else {
      console.log("history is unavailable");
    }
  }, []);

  useLayoutEffect(() => {
    switch (incomingdata.topic) {
      case `vehicle/${activeImei}/tracker`:
        var datas = incomingdata.message.split(",");
        setLat(datas[6].split(":")[1]);
        setLong(datas[7].split(":")[1]);
        //setAltitude(datas[8].split(":")[1]);
        setTrackedSatelites(datas[3].split(":")[1]);
        setTotalsates(datas[4].split(":")[1]);
        localStorage.setItem("datass", incomingdata.message);
        break;
      case `vehicle/${activeImei}/state`:
        setState(incomingdata.message);
        break;
      case `vehicle/${activeImei}/battery`:
        setBattery(incomingdata.message);
        break;
      case `vehicle/${activeImei}/liion`:
        setLiion(incomingdata.message);
        break;
      case `vehicle/${activeImei}/speed`:
        setSpeed(incomingdata.message);
        break;
      case `vehicle/${activeImei}/ignition`:
        setIgnition(incomingdata.message);
        break;
      case `vehicle/${activeImei}/gsm_level`:
        setGsm_level(incomingdata.message);
        break;
      default:
        console.log(
          `unrecognised data on topic: ${incomingdata.topic} data: ${incomingdata.message}`
        );
    }
  }, [incomingdata, activeImei]);

  const LocationMarker = () => {
    const [position, setPosition] = useState(null);
    const map = useMap();
    //L.map("map", { rotate: true, touchRotate: true }).setView([55, 10], 4);
    useEffect(() => {
      map.locate().on("locationfound", function (e) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
        const radius = e.accuracy;
        const circle = L.circle(e.latlng, radius);
        circle.addTo(map);
      });
    }, [map]);
    return position === null ? null : (
      <Marker position={position} icon={locationIcon}>
        <Popup>You are Here</Popup>
      </Marker>
    );
  };

  const CarLocationMaker = () => {
    const map = useMap();
  
    useEffect(() => {
      if (lat && long) {
        map.setView([lat, long], map.getZoom(), {
          animate: true,
        });
      }
    }, [map]); // Use lat and long instead of carlocation
  
    return (
      <Marker position={[lat, long]} icon={carIcon}>
      <Popup>
        <div className="popupmessage">
          <div className="popupInfoItem">
            <span className="popupInfoKey">Vehicle:</span>
            <span className="popupInfoValue">{activeVehicle}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Speed:</span>
            <span className="popupInfoValue">{speed}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Battery:</span>
            <span className="popupInfoValue">{battery}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Network Level:</span>
            <span className="popupInfoValue">{gsm_level}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">State:</span>
            <span className="popupInfoValue">{state}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Liion:</span>
            <span className="popupInfoValue">{liion}</span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Fuel Level:</span>
            <span className="popupInfoValue"> </span>
          </div>
          <div className="popupInfoItem">
            <span className="popupInfoKey">Engine:</span>
            <span className="popupInfoValue"> {engine}</span>
          </div>
        </div>
      </Popup>
    </Marker>
    );
  };

  return (
    <div className="master">
      <MapContainer
        center={[-1.286, 36.81]}
        zoom={ZOOM_LEVEL}
        rotate={true}
        touchRotate={true}
        eventHandlers={{ touchRotate: true, rotate: true }}
        scrollWheelZoom={true}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          url={osm.maptiler.url}
          attribution={osm.maptiler.attribution}
        />

        {findme ? <LocationMarker /> : <CarLocationMaker />}

        <div
          className="findcar"
          onClick={(e) => {
            e.preventDefault();
            setFindme(false);
          }}
        >
          <FaCar className="importedicon2" />
        </div>

        <div
          className="findme"
          onClick={(e) => {
            e.preventDefault();
            setFindme(true);
          }}
        >
          <BiCurrentLocation className="importedicon2" />
        </div>

        <div className="datamaster">
          <div className="staticmast">
            <span onClick={handleClick}>Live Data</span>

            {click === true ? (
              <>
                <FaAngleUp className="importedicon" onClick={handleClick} />
              </>
            ) : (
              <>
                <FaAngleDown className="importedicon" onClick={handleClick} />
              </>
            )}
          </div>

          <div className={click ? "children" : "outcast"}>
            <div>
              <span className="popupInfo">Vehicle:</span>
              <span className="popupValue">{activeVehicle}</span>
            </div>

            <div>
              <span className="popupInfo">Speed:</span>
              <span className="popupValue">{speed}</span>
            </div>
            <div>
              <span className="popupInfo">Battery:</span>
              <span className="popupValue">{battery}</span>
            </div>
            <div>
              <span className="popupInfo">Network Level:</span>
              <span className="popupValue">{gsm_level}</span>
            </div>
            <div>
              <span className="popupInfo">State:</span>
              <span className="popupValue">{state}</span>
            </div>
            <div>
              <span className="popupInfo">Liion:</span>
              <span className="popupValue">{liion}</span>
            </div>

            <div>
              <span className="popupInfo">Fuel Level:</span>
              <span className="popupValue"></span>
            </div>

            <div>
              <span className="popupInfo">Tracked Satelites:</span>
              <span className="popupValue">{trackedsates}</span>
            </div>

            <div>
              <span className="popupInfo">Total Satelites:</span>
              <span className="popupValue">{total_sates}</span>
            </div>

            <div className="mmwwiisshho">
              <span className="popupInfo">Engine:</span>
              <span className="popupValue"> {engine}</span>
            </div>
          </div>
        </div>
      </MapContainer>
    </div>
  );
}
